import { useLogin } from "../../../APIContext/LoginContext";
import NavbarCustom from "../../../Components/NavbarCustom";
import "./style.css";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function LoginPage() {
  const [username_or_email, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { user, login } = useLogin();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role === "PARENT") {
      navigate("/");
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await login({ username_or_email, password });

    console.log(result);

    if (result.success) {
      navigate("/");
    }
  };

  return (
    <>
      <NavbarCustom />

      <div className="auth-wrapper brightness">
        <div className="auth-card brightness">
          <div className="card-box">
            <h2 className="auth-title text-clip">LOGIN</h2>

            <form
              className="auth-form"
              style={{ marginTop: "2rem" }}
              onSubmit={handleSubmit}
            >
              <label className="text-clip">Username or Email Address *</label>
              <input
                type="text"
                value={username_or_email}
                onChange={(e) => setUsername(e.target.value)}
                required
              />

              <label className="text-clip" style={{ marginTop: "1rem" }}>
                Password *
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <div className="auth-row" style={{ justifyContent: "flex-end" }}>
                <Link
                  to="/forgot-password"
                  className="auth-forgot"
                  style={{ textDecoration: "none" }}
                >
                  Forgot Password?
                </Link>
              </div>

              <button className="auth-login-btn" type="submit">
                LOGIN
              </button>
            </form>

            <hr className="auth-divider" />

            <p className="auth-note text-clip">
              Don’t Have An Account? Create A New Account Here
            </p>
            <button
              className="auth-create-btn"
              onClick={() => navigate("/create-an-account")}
            >
              <span className="text-clip">Create Your New Account</span>
            </button>
          </div>
        </div>

        <div className="auth-side-image"></div>
      </div>
    </>
  );
}
